// get brower
export function GetCurrentBrowser () {
    let ua = navigator.userAgent.toLowerCase()
    let browserType = null
    if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
      browserType = 'IE'
    } else if (ua.match(/firefox/) != null) {
      browserType = 'Firefox'
    } else if (ua.match(/ucbrowser/) != null) {
      browserType = 'UC'
    } else if (ua.match(/opera/) != null || ua.match(/opr/) != null) {
      browserType = 'Opera'
    } else if (ua.match(/bidubrowser/) != null) {
      browserType = 'Baidu'
    } else if (ua.match(/metasr/) != null) {
      browserType = 'Sougou'
    } else if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
      browserType = 'QQ'
    } else if (ua.match(/maxthon/) != null) {
      browserType = 'Maxthon'
    } else if (ua.match(/chrome/) != null) {
      var is360 = _mime('type', 'application/vnd.chromium.remoting-viewer')
      if (is360) {
        browserType = '360'
      } else {
        browserType = 'Chrome'
      }
    } else if (ua.match(/micromessenger/) != null) {
      browserType = 'Wechat'
    } else if (ua.match(/samsungbrowser/) != null) {
      browserType = 'Samsung'
    } else if (ua.match(/miuibrowser/) != null) {
      browserType = 'Xiaomi'
    } else if (ua.match(/maxthon/) != null) {
      browserType = '傲游'
    } else if (ua.match(/oppo/) != null) {
      browserType = 'Oppo'
    } else if (ua.match(/huawei/) != null) {
      browserType = 'Huawei'
    } else if (ua.match(/honor/) != null) {
      browserType = 'Honor'
    } else if (ua.match(/vivo/) != null) {
      browserType = 'Vivo'
    } else if (ua.match(/crios/) != null) {
      browserType = 'Chrome'
    } else if (ua.indexOf("safari") > -1 && ua.indexOf("chrome") < 1 && ua.indexOf("crios") < 1) {
      browserType = 'Safari'
    } else {
      browserType = 'Others'
    }
    return browserType
  }
   
function _mime (option, value) {
    var mimeTypes = navigator.mimeTypes
    for (var mt in mimeTypes) {
        if (mimeTypes[mt][option] === value) {
        return true
        }
    }
    return false
}
   
// get os
export function GetOs () {
    let sUserAgent = navigator.userAgent.toLocaleLowerCase()
    let isWin = (navigator.platform === 'win32') || (navigator.platform === 'windows') || sUserAgent.indexOf("win") > -1;
    let isMac = (navigator.platform === 'mac68k') || (navigator.platform === 'macppc') || (navigator.platform === 'macintosh') || (navigator.platform === 'macintel')
    if (isMac) return 'Mac'
    var isUnix = (navigator.platform === 'x11' || sUserAgent.indexOf("unix") > -1 || sUserAgent.indexOf("sunname") > -1 || sUserAgent.indexOf("bsd") > -1) && !isWin && !isMac
    if (isUnix) return 'Unix'
    var isLinux = (String(navigator.platform).indexOf('linux') > -1)
    if (isLinux) return 'Linux'
    if (isWin) {
        let name = "Windows";
        if(sUserAgent.indexOf("windows nt 5.0") > -1) {
            name = "Windows 2000";
        } else if(sUserAgent.indexOf("windows nt 5.1") > -1 || sUserAgent.indexOf("windows nt 5.2") > -1) {
            name = "Windows XP";
        } else if(sUserAgent.indexOf("windows nt 6.0") > -1) {
            name = "Windows Vista";
        } else if(sUserAgent.indexOf("windows nt 6.1") > -1 || sUserAgent.indexOf("windows 7") > -1) {
            name = "Windows 7";
        } else if(sUserAgent.indexOf("windows nt 6.2") > -1 || sUserAgent.indexOf("windows 8") > -1) {
            name = "Windows 8";
        } else if(sUserAgent.indexOf("windows nt 6.3") > -1) {
            name = "Windows 8.1";
        } else if(sUserAgent.indexOf("windows nt 6.2") > -1 || sUserAgent.indexOf("windows nt 10.0") > -1) {
            name = "Windows 10";
        } else {
            name = "Unknown";
        }
        return name
    }
    if (sUserAgent.indexOf('android') > -1) return 'Android'
    if (sUserAgent.indexOf('iphone') > -1) return 'iPhone'
    if (sUserAgent.indexOf('symbianos') > -1) return 'SymbianOS'
    if (sUserAgent.indexOf('windows phone') > -1) return 'Windows Phone'
    if (sUserAgent.indexOf('ipad') > -1) return 'iPad'
    if (sUserAgent.indexOf('ipod') > -1) return 'iPod'
    return 'Others'
}
  